const FacebookConnect = () => {
  return (
    <svg
      width="210"
      height="118"
      viewBox="0 0 210 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_9_21604)">
        <rect x="35" y="10" width="48" height="48" rx="8" fill="white" />
        <rect
          x="36"
          y="11"
          width="46"
          height="46"
          rx="7"
          stroke="#E2E2EA"
          strokeWidth="2"
        />
        <g clipPath="url(#clip0_9_21604)">
          <path
            opacity="0.96"
            d="M57.9119 36.1606L52.1511 36.3825C51.802 36.3953 51.4556 36.315 51.1468 36.1496C50.838 35.9842 50.5776 35.7398 50.3917 35.4405C50.2057 35.1413 50.1008 34.7979 50.0874 34.4448C50.074 34.0916 50.1526 33.7411 50.3153 33.4283L53.0018 28.2687L55.6997 23.1133C55.8629 22.8005 56.1047 22.5366 56.4007 22.3483C56.6967 22.1599 57.0366 22.0538 57.386 22.0405C57.7355 22.0272 58.0823 22.1072 58.3914 22.2725C58.7006 22.4378 58.9613 22.6825 59.1473 22.9821L62.2162 27.9179L65.2846 32.8554C65.4707 33.1548 65.5756 33.4985 65.5888 33.8519C65.602 34.2054 65.523 34.5561 65.3596 34.8688C65.1963 35.1816 64.9544 35.4453 64.6583 35.6334C64.3623 35.8216 64.0225 35.9276 63.673 35.9408L57.9119 36.1606Z"
            fill="#032250"
          />
          <path
            opacity="0.87"
            d="M59.9677 31.7431L65.7305 31.5362C66.0791 31.5247 66.4245 31.6061 66.7323 31.7721C67.04 31.9381 67.2992 32.1829 67.4841 32.4821C67.669 32.7813 67.7728 33.1243 67.7854 33.4769C67.798 33.8295 67.7189 34.1792 67.5558 34.4911L64.8562 39.6464L62.1545 44.7963C61.9903 45.1089 61.7478 45.3722 61.4512 45.5597C61.1546 45.7474 60.8144 45.8527 60.4648 45.8653C60.1152 45.8778 59.7685 45.7971 59.4595 45.6312C59.1505 45.4652 58.8901 45.22 58.7045 44.92L55.647 39.9765L52.5896 35.0334C52.4037 34.7336 52.2991 34.3896 52.2865 34.0359C52.2738 33.6823 52.3535 33.3315 52.5174 33.0189C52.6814 32.7063 52.9238 32.4429 53.2204 32.2552C53.517 32.0675 53.8573 31.9622 54.2069 31.9498L59.9677 31.7431Z"
            fill="#149DFF"
          />
        </g>
      </g>
      <path
        d="M103 29.0006C102.735 29.0006 102.48 29.1059 102.293 29.2935C102.105 29.481 102 29.7354 102 30.0006C102 30.2658 102.105 30.5201 102.293 30.7077C102.48 30.8952 102.735 31.0006 103 31.0006H108.586L107.293 32.2936C107.111 32.4822 107.01 32.7348 107.012 32.997C107.014 33.2592 107.12 33.51 107.305 33.6954C107.49 33.8808 107.741 33.986 108.003 33.9882C108.266 33.9905 108.518 33.8897 108.707 33.7076L111.707 30.7076C111.894 30.52 112 30.2657 112 30.0006C112 29.7354 111.894 29.4811 111.707 29.2936L108.707 26.2936C108.615 26.1981 108.504 26.1219 108.382 26.0695C108.26 26.0171 108.129 25.9895 107.996 25.9883C107.863 25.9872 107.732 26.0125 107.609 26.0627C107.486 26.113 107.374 26.1873 107.28 26.2812C107.186 26.3751 107.112 26.4867 107.062 26.6096C107.012 26.7325 106.986 26.8642 106.988 26.997C106.989 27.1298 107.016 27.261 107.069 27.383C107.121 27.505 107.197 27.6153 107.293 27.7076L108.586 29.0006H103ZM107 39.0006C107.265 39.0006 107.519 38.8952 107.707 38.7077C107.894 38.5201 108 38.2658 108 38.0006C108 37.7354 107.894 37.481 107.707 37.2935C107.519 37.1059 107.265 37.0006 107 37.0006H101.414L102.707 35.7076C102.802 35.6153 102.878 35.505 102.931 35.383C102.983 35.261 103.011 35.1297 103.012 34.997C103.013 34.8642 102.988 34.7325 102.938 34.6096C102.887 34.4867 102.813 34.3751 102.719 34.2812C102.625 34.1873 102.514 34.113 102.391 34.0627C102.268 34.0125 102.136 33.9872 102.003 33.9883C101.871 33.9895 101.739 34.0171 101.617 34.0695C101.495 34.1219 101.385 34.1981 101.293 34.2936L98.2928 37.2936C98.1053 37.4811 98 37.7354 98 38.0006C98 38.2657 98.1053 38.52 98.2928 38.7076L101.293 41.7076C101.482 41.8897 101.734 41.9905 101.997 41.9882C102.259 41.986 102.51 41.8808 102.695 41.6954C102.88 41.51 102.986 41.2592 102.988 40.997C102.99 40.7348 102.889 40.4822 102.707 40.2936L101.414 39.0006H107Z"
        fill="#282560"
      />
      <path
        d="M108 51.0006C108 51.2658 107.895 51.5201 107.707 51.7077C107.52 51.8952 107.265 52.0006 107 52.0006H102.414L103.707 53.2936C103.989 53.5763 104.132 53.986 104.089 54.3993C104.046 54.8125 103.823 55.1881 103.488 55.402C103.153 55.6158 102.741 55.6426 102.379 55.4743C102.017 55.3061 101.757 54.9615 101.707 54.5612C101.657 54.161 101.828 53.7644 102.158 53.5357L100.707 52.0006H95C94.7348 52.0006 94.4804 51.8952 94.2929 51.7077C94.1054 51.5201 94 51.2658 94 51.0006C94 50.7354 94.1054 50.481 94.2929 50.2935C94.4804 50.1059 94.7348 50.0006 95 50.0006H100.586L99.293 48.7076C98.8053 48.22 98.8053 47.4811 99.293 46.9936C99.7805 46.5061 100.519 46.5061 101.007 46.9936L104.007 49.9936C104.195 50.1811 104.3 50.4354 104.3 50.7006C104.3 50.9657 104.195 51.22 104.007 51.4076L101.007 54.4076C100.519 54.8952 99.7805 54.8952 99.293 54.4076C98.8053 53.92 98.8053 53.1811 99.293 52.6936L100.586 51.0006H95C94.7348 51.0006 94.4804 50.8952 94.2929 50.7077C94.1054 50.5201 94 50.2658 94 50.0006C94 49.7354 94.1054 49.481 94.2929 49.2935C94.4804 49.1059 94.7348 49.0006 95 49.0006H100.586L99.293 47.7076C99.011 47.425 98.868 47.0153 98.9111 46.602C98.9543 46.1888 99.1768 45.8132 99.5121 45.5994C99.8473 45.3856 100.26 45.3587 100.622 45.5269C100.984 45.6951 101.244 46.0397 101.293 46.4401C101.343 46.8404 101.172 47.237 100.841 47.4657L102.293 49.0006H107C107.265 49.0006 107.519 49.1059 107.707 49.2935C107.894 49.481 108 49.7354 108 50.0006Z"
        fill="#149DFF"
      />
      <path
        d="M149.999 54.0006H156.294C156.556 54.0006 156.807 54.1059 156.993 54.2935C157.18 54.481 157.294 54.7354 157.294 55.0006C157.294 55.2658 157.18 55.5201 156.993 55.7077C156.807 55.8952 156.556 56.0006 156.294 56.0006H149.999C149.734 56.0006 149.48 55.8952 149.293 55.7077C149.105 55.5201 149 55.2658 149 55.0006C149 54.7354 149.105 54.481 149.293 54.2935C149.48 54.1059 149.734 54.0006 149.999 54.0006Z"
        fill="#282560"
      />
    </svg>
  );
};

export default FacebookConnect;

export const LogoNew = () => {
  return (
    <svg
      width="18"
      height="24"
      viewBox="0 0 18 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9_20493)">
        <path
          opacity="0.96"
          d="M7.91194 14.1606L2.15112 14.3825C1.80197 14.3953 1.45563 14.315 1.14683 14.1496C0.838026 13.9842 0.577608 13.7398 0.391668 13.4405C0.20573 13.1413 0.100803 12.7979 0.0874042 12.4448C0.0740051 12.0916 0.152604 11.7411 0.315325 11.4283L3.00182 6.26873L5.69969 1.11331C5.8629 0.80046 6.10469 0.536599 6.40072 0.348271C6.69675 0.159943 7.03659 0.05379 7.38604 0.0404876C7.73549 0.0271852 8.08226 0.107203 8.39143 0.272493C8.70062 0.437782 8.96132 0.682516 9.14732 0.982076L12.2162 5.91789L15.2846 10.8554C15.4707 11.1548 15.5756 11.4985 15.5888 11.8519C15.602 12.2054 15.523 12.5561 15.3596 12.8688C15.1963 13.1816 14.9544 13.4453 14.6583 13.6334C14.3623 13.8216 14.0225 13.9276 13.673 13.9408L7.91194 14.1606Z"
          fill="#032250"
        />
        <path
          opacity="0.87"
          d="M9.96771 9.74307L15.7305 9.53622C16.0791 9.52474 16.4245 9.60607 16.7323 9.77206C17.04 9.93807 17.2992 10.1829 17.4841 10.4821C17.669 10.7813 17.7728 11.1243 17.7854 11.4769C17.798 11.8295 17.7189 12.1792 17.5558 12.4911L14.8562 17.6464L12.1545 22.7963C11.9903 23.1089 11.7478 23.3722 11.4512 23.5597C11.1546 23.7474 10.8144 23.8527 10.4648 23.8653C10.1152 23.8778 9.76845 23.7971 9.45946 23.6312C9.15047 23.4652 8.8901 23.22 8.70449 22.92L5.64702 17.9765L2.58956 13.0334C2.40366 12.7336 2.29913 12.3896 2.28646 12.0359C2.2738 11.6823 2.35345 11.3315 2.51741 11.0189C2.68138 10.7063 2.92385 10.4429 3.22044 10.2552C3.51703 10.0675 3.85725 9.96216 4.20689 9.94977L9.96771 9.74307Z"
          fill="#149DFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_9_20493">
          <rect
            width="17.8286"
            height="24"
            fill="white"
            transform="translate(0.0859375)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CustomArrowSVG = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99979 5.00057C7.73457 5.00057 7.48022 5.10593 7.29268 5.29346C7.10514 5.481 6.99979 5.73535 6.99979 6.00057C6.99979 6.26579 7.10514 6.52014 7.29268 6.70768C7.48022 6.89521 7.73457 7.00057 7.99979 7.00057H13.5858L12.2928 8.29357C12.1106 8.48217 12.0098 8.73477 12.0121 8.99697C12.0144 9.25917 12.1196 9.50998 12.305 9.69539C12.4904 9.8808 12.7412 9.98596 13.0034 9.98824C13.2656 9.99052 13.5182 9.88973 13.7068 9.70757L16.7068 6.70757C16.8943 6.52004 16.9996 6.26573 16.9996 6.00057C16.9996 5.73541 16.8943 5.4811 16.7068 5.29357L13.7068 2.29357C13.6145 2.19806 13.5042 2.12188 13.3822 2.06947C13.2602 2.01706 13.129 1.98947 12.9962 1.98832C12.8634 1.98717 12.7317 2.01247 12.6088 2.06275C12.4859 2.11303 12.3743 2.18728 12.2804 2.28117C12.1865 2.37507 12.1122 2.48672 12.062 2.60962C12.0117 2.73251 11.9864 2.86419 11.9875 2.99697C11.9887 3.12975 12.0163 3.26097 12.0687 3.38297C12.1211 3.50498 12.1973 3.61532 12.2928 3.70757L13.5858 5.00057H7.99979ZM11.9998 15.0006C12.265 15.0006 12.5194 14.8952 12.7069 14.7077C12.8944 14.5201 12.9998 14.2658 12.9998 14.0006C12.9998 13.7354 12.8944 13.481 12.7069 13.2935C12.5194 13.1059 12.265 13.0006 11.9998 13.0006H6.41379L7.70679 11.7076C7.8023 11.6153 7.87848 11.505 7.93089 11.383C7.9833 11.261 8.01088 11.1297 8.01204 10.997C8.01319 10.8642 7.98789 10.7325 7.93761 10.6096C7.88733 10.4867 7.81307 10.3751 7.71918 10.2812C7.62529 10.1873 7.51364 10.113 7.39074 10.0627C7.26784 10.0125 7.13616 9.98716 7.00339 9.98832C6.87061 9.98947 6.73939 10.0171 6.61738 10.0695C6.49538 10.1219 6.38503 10.1981 6.29279 10.2936L3.29279 13.2936C3.10532 13.4811 3 13.7354 3 14.0006C3 14.2657 3.10532 14.52 3.29279 14.7076L6.29279 17.7076C6.48139 17.8897 6.73399 17.9905 6.99619 17.9882C7.25838 17.986 7.5092 17.8808 7.6946 17.6954C7.88001 17.51 7.98518 17.2592 7.98746 16.997C7.98974 16.7348 7.88894 16.4822 7.70679 16.2936L6.41379 15.0006H11.9998Z"
        fill="#7E7E8F"
      />
    </svg>
  );
};

export const InstagramImage = () => {
  return (
    <svg
      width="320"
      height="540"
      viewBox="0 0 320 540"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="320" height="540" rx="8" fill="#E3EFFC" />
      <rect
        x="40.625"
        y="29"
        width="238.75"
        height="482"
        rx="44"
        fill="url(#pattern0_9_20888)"
      />
      <defs>
        <pattern
          id="pattern0_9_20888"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use transform="matrix(0.006169 0 0 0.00299677 -1.33149 -0.0186722)" />
        </pattern>
        <image id="image0_9_20888" width="608" height="342" />
      </defs>
    </svg>
  );
};
